import authRest from './auth';
import historyRest from './history';
import profileRest from './profile';
import subscriptionRest from './subscription';

const helpers = {
    ...authRest,
    ...historyRest,
    ...profileRest,
    ...subscriptionRest,
};

export default helpers;